import { Body, Controller, Post } from '@nestjs/common';
import { LoginAndRegistrationService } from '../services/login-and-registration.service';
import { RegisterRequest } from '../models/requests/register.request';
import { LoginRequest } from '../models/requests/login.request';
import {
  ApiConflictResponse,
  ApiForbiddenResponse,
  ApiOkResponse,
  ApiOperation,
  ApiResponse,
  ApiTags,
  ApiUnprocessableEntityResponse,
} from '@nestjs/swagger';
import { AuthenticatedUserResponse } from '@ip6m/server/shared';

@Controller('user-auth')
@ApiResponse({
  status: 400,
  description: 'Invalid or incomplete request.',
})
@ApiTags('login and registration')
export class LoginAndRegistrationController {
  constructor(
    private loginAndRegistrationService: LoginAndRegistrationService
  ) {}

  @Post('register')
  @ApiOperation({
    operationId: 'register',
    description: 'Register new user.',
  })
  @ApiOkResponse({
    type: AuthenticatedUserResponse,
  })
  @ApiConflictResponse({
    description: 'Existing email address.',
  })
  @ApiUnprocessableEntityResponse({ description: 'Incomplete user data.' })
  public async postRegister(
    @Body() registerRequest: RegisterRequest
  ): Promise<AuthenticatedUserResponse> {
    return this.loginAndRegistrationService.register(registerRequest);
  }

  @Post('login')
  @ApiOperation({
    operationId: 'login',
    description: 'Login with existing user.',
  })
  @ApiOkResponse({
    type: AuthenticatedUserResponse,
  })
  @ApiForbiddenResponse({
    description: 'Invalid credentials',
  })
  public async postLogin(
    @Body() { email, password }: LoginRequest
  ): Promise<AuthenticatedUserResponse> {
    return this.loginAndRegistrationService.login(email, password);
  }
}
